import Button from '__core/modules/atoms/Button/Button';
import InputText from '__core/modules/atoms/InputText/InputText';
import Image from 'app/components/Image/Image';
import React, { useState } from 'react';

function UIImage() {
  const [imageUrl, setImageUrl] = useState('');
  const [displayedUrl, setDisplayedUrl] = useState('');

  const handleShowImage = () => {
    setDisplayedUrl(imageUrl);
  };

  return (
    <div>
      <div className="d-flex align-items-end mb-3">
        <div className="w-100 mr-3">
          <InputText label="Image URL" onChange={(e) => setImageUrl(e.target.value)} value={imageUrl} />
        </div>
        <div className="w-25">
          <Button onClick={handleShowImage} text="Ver" />
        </div>
      </div>

      {displayedUrl && (
        <div className="mb-3">
          <div
            style={{
              border: '2px dashed #c6cfdc',
              padding: '16px',
              borderRadius: '4px',
              backgroundColor: '#f7f9fc',
              overflow: 'hidden',
            }}
          >
            <Image src={displayedUrl} style={{ maxWidth: '100%', height: 'auto', display: 'block' }} />
          </div>
        </div>
      )}
    </div>
  );
}

export default UIImage;
